import { generalErrorAdd } from "../Actions/Error.action";

export const handleApiErrors = (error, actionCallback = null) => (dispatch) => {
    if (Object.hasOwn(error, "general"))
    {
        const errors = { 
            errors: error['general']?.map(e => ({ 
                messageText: e, 
                messageType: "Pink", 
                dismissible: true, 
                timeToLive: 10, 
                messageId: crypto.randomUUID() 
            }))
        }
        dispatch(generalErrorAdd(errors));
    }

    if (actionCallback) {
        dispatch(actionCallback(error));
    }
}
